import { render, staticRenderFns } from "./PlantDocsList.vue?vue&type=template&id=c230a86c&scoped=true&"
import script from "./PlantDocsList.vue?vue&type=script&lang=js&"
export * from "./PlantDocsList.vue?vue&type=script&lang=js&"
import style0 from "./PlantDocsList.vue?vue&type=style&index=0&id=c230a86c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c230a86c",
  null
  
)

export default component.exports